<template>
    <div ref="documentsListContainer" class="container mb-5">

        <div class="k-tabs">
            <ul class="k-tabs__list">
                <li class="k-tabs__item k-tabs__item--active">
                    <span class="k-tabs__link k-tabs__list--nohover"><slot v-slot:title></slot></span>
                </li>
            </ul>

            <div class="d-flex ">
                <div class="k-tabs__actions mr-3">
                    <a :href="createDocumentLink" class="k-tabs__actions-link"><svg class="k-tabs__actions-icon k-tabs__actions-icon--before" role="img" width="15" height="15">
                        <use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use>
                    </svg>  Přidat dokument</a>
                </div>

                <div class="k-tabs__sorting">
                    <span class="k-tabs__sorting-text">Řadit podle:</span>

                    <select @change="sortChanged" v-model="orderBy" ref="sortSelect1" class="form-control">
                        <option value="date">Data vložení</option>
                        <option value="downloads">Počtu stažení</option>
                        <option value="size">Velikosti</option>
                    </select>


                    <select @change="sortChanged" v-model="orderDirection" ref="sortSelect2" class="form-control">
                        <option value="asc">Vzestupně</option>
                        <option value="desc">Sestupně</option>
                    </select>
                </div>
            </div>


        </div>


        <transition-group name="list-complete" tag="div" class="k-table">
            <div v-for="document in documents.data" :key="document.id" class="k-table__row">
                <div class="k-table__cell">
                    <div class="k-file-meta k-mr-20">
                        <svg class="k-file-meta__icon" role="img" width="24" height="25">
                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#file-pdf"/>
                        </svg>

                        <div class="k-file-meta__text">
                            {{ document.size_formatted }}
                        </div>
                    </div>

                   <div class="mr-auto" >
                            <a  :href="document.detail_url" class="mb-1 d-block">
                                <strong class="k-strong">
                                    {{ document.title }}
                                </strong>
                            </a>

                            <div class="k-table__cell-meta ml-0">
                                <a v-for="(url, title) in document.categories" class="k-link mr-2" :href="url">{{ title }}</a>
                            </div>
                        </div>

                    <span class="k-table__cell-meta">{{ document.created_at }}</span>
                </div>

                <div class="k-table__cell k-table__cell--action">
                    <a :href="document.detail_url" class="k-action k-action--control">
                        <svg class="k-action__icon" role="img" width="15" height="15">
                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#eye"/>
                        </svg>
                        Zobrazit
                    </a>
                </div>

                <div class="k-table__cell k-table__cell--action">
                    <template v-if="document.zip_url !== null">
                        <a :href="document.zip_url" class="k-action k-action--control">
                            <svg class="k-action__icon" role="img" width="15" height="15">
                                <use fill="currentColor" xlink:href="/images/spritesheet.svg#download"/>
                            </svg>
                            Stáhnout
                        </a>
                    </template>
                    <template v-else>
                        <strong>Zpracovávám</strong>
                    </template>
                </div>
            </div>
            <div key="0" v-if="documents.data && documents.data.length === 0" class="k-table__cell p-2">
                Nebyly nalezeny žádné dokumenty.
            </div>
        </transition-group>

        <pagination class="mt-5" :data="documents" @pagination-change-page="paginate" :limit="2"></pagination>

    </div>
</template>

<script>
    import Choices from 'choices.js';
    import Pagination from 'laravel-vue-pagination';

    export default {

        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            },
            initialSearch: {
                type: String,
                default: ''
            }
        },

        data: function () {
            return {
                documents: {},
                orderBy: 'date',
                orderDirection: 'desc',
                search: this.initialSearch
            };
        },

        computed: {
            createDocumentLink: function() {
                return Links.createDocument;
            }
        },

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            orderBy: this.orderBy,
                            orderDirection: this.orderDirection,
                            search: this.search
                        }
                    });

                    if (result.status === 200 && result.data) {
                        this.documents = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Paginate results
             *
             * @param page
             * @returns void
             */
            paginate: async function(page = 1) {
                await this.getData(page);
                if (this.$refs.documentsListContainer) {
                    setTimeout( () => {
                        this.$scrollTo(this.$refs.documentsListContainer, 500, {offset: -80});
                    }, 300);
                }
            },

            /**
             * Sort changed event handler
             *
             * @returns void
             */
            sortChanged() {
                this.getData();
            }
        },

        created() {
            // listen for search input event
            window.events.$on('searchInputSubmitted', (search, preventScroll = false) => {
                this.search = search;
                if (preventScroll) {
                    this.getData(1);
                }
                else {
                    this.paginate(1);
                }
            });
        },

        mounted() {
            // get table data
            this.getData();

            // register choices
            let selects = [
                this.$refs.sortSelect1,
                this.$refs.sortSelect2
            ];

            for (let sort of selects) {
                new Choices(sort, {
                    classNames: {
                        containerOuter: 'choices k-sort-select-choices',
                        containerInner: 'choices__inner',
                        input: 'choices__input',
                        inputCloned: 'choices__input--cloned',
                        list: 'choices__list',
                        listItems: 'choices__list--multiple',
                        listSingle: 'choices__list--single',
                        listDropdown: 'choices__list--dropdown',
                        item: 'choices__item',
                        itemSelectable: 'choices__item--selectable',
                        itemDisabled: 'choices__item--disabled',
                        itemChoice: 'choices__item--choice',
                        placeholder: 'choices__placeholder',
                        group: 'choices__group',
                        groupHeading: 'choices__heading',
                        button: 'choices__button',
                        activeState: 'is-active',
                        focusState: 'is-focused',
                        openState: 'is-open',
                        disabledState: 'is-disabled',
                        highlightedState: 'is-highlighted',
                        hiddenState: 'is-hidden',
                        flippedState: 'is-flipped',
                        loadingState: 'is-loading',
                        noResults: 'has-no-results',
                        noChoices: 'has-no-choices'
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity .5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }
</style>
